/**
 * This component contains the fields on the Vendor Application related to
 * International Payments for International vendors.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@mui/material';
import BankFields from '../BankFields/BankFields';
import {
  isFieldDisabled,
  getApplicationStatus,
  showWireButton,
  showWireFields,
} from '../../Lib/Utils/FormUtils/vendor-application';
import {
  makeBankValues,
  makeBankNames,
} from '../../Lib/Utils/FormUtils/bank-fields';

import styles from '../VendorApplication/VendorApplication.module.css';
import isDomestic from '../../Lib/Utils/VendorApplication/is-domestic';

function WireBankFields(props) {
  const {
    vendor,
    form,
    wirePayment,
    toggleWire,
    emptyFields,
    updateBankField,
    onBlur,
    // TODO: [HALO-MIGRATION] Remove isMigratedToHalo prop after migration is complete
    isMigratedToHalo,
  } = props;
  const domesticPayment = isDomestic(form.payment_country);
  const applicationStatus = getApplicationStatus(vendor);

  return (
    <div>
      {showWireButton(domesticPayment, applicationStatus) && (
        <div>
          <Link
            component="button"
            variant="body2"
            onClick={isMigratedToHalo ? undefined : toggleWire}
            id="va-wire-button"
            sx={
              isMigratedToHalo
                ? { pointerEvents: 'none', color: 'grey.500' }
                : undefined
            }
          >
            {!wirePayment ? 'Click here for wire payment' : 'Hide wire payment'}
          </Link>
          <p className={styles.subText}>Optional</p>
          <br />
        </div>
      )}

      {showWireFields(form, wirePayment, applicationStatus) && (
        <BankFields
          values={makeBankValues(form, true)}
          names={makeBankNames(true)}
          prefix="va-wire"
          onChange={updateBankField}
          disabled={
            isFieldDisabled(applicationStatus) ||
            !props.perms.canUpdate ||
            isMigratedToHalo
          }
          header="Wire Payment Info"
          onBlur={onBlur}
          emptyFields={emptyFields}
          domestic={domesticPayment}
        />
      )}
    </div>
  );
}

WireBankFields.propTypes = {
  form: PropTypes.shape({}).isRequired,
  vendor: PropTypes.shape({}).isRequired,
  wirePayment: PropTypes.bool.isRequired,
  toggleWire: PropTypes.func.isRequired,
  emptyFields: PropTypes.shape({}).isRequired,
  updateBankField: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  perms: PropTypes.shape({
    canUpdate: PropTypes.bool,
  }).isRequired,
  // TODO: [HALO-MIGRATION] Remove isMigratedToHalo prop after migration is complete
  isMigratedToHalo: PropTypes.bool,
};

export default WireBankFields;
